import React from 'react'
import map from 'ramda/src/map'
import classNames from 'classnames'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import ButtonNew from 'root/src/client/web/base/ButtonNew'
import { ltMdMediaQuery, ltGtMediaQuery, ltSmMediaQuery } from 'root/src/client/web/commonStyles'
import Link from 'root/src/client/web/base/Link'

const commonStyle = {
	itemMargin: {
		margin: [[0, 0, 20, 0]],
	},
	left: {
		margin: [[0, 0, 0, 120]],
		[ltMdMediaQuery]: {
			margin: [[0, 0, 0, 80]],
		},
		[ltGtMediaQuery]: {
			margin: [[0, 0, 0, 30]],
		},
	},
	right: {
		margin: [[0, 40, 0, 'auto']],
		[ltGtMediaQuery]: {
			margin: [[0, 30, 0, 'auto']],
		},
		[ltSmMediaQuery]: {
			margin: [[0, 'auto', 0, 30]],
		},
	},
	alignLeft: {
		'& > *': {
			textAlign: 'left',
		},
	},
	alignRight: {
		'& *': {
			textAlign: 'right',
		},
	},
}

const Buttons = withStyles({
	alignLeft: {
		display: 'flex',
		'& > *': {
			margin: [[0, 20, 0, 0]],
		},
		justifyContent: 'flex-start',
	},
	alignRight: {
		display: 'flex',
		'& > *': {
			margin: [[0, 0, 0, 20]],
		},
		justifyContent: 'flex-end',
	},
}, { name: 'MuiSectionButton' })(({ buttons, classes, align }) => (
	<div className={classNames(
		align === 'left' && classes.alignLeft,
		align === 'right' && classes.alignRight,
	)}
	>
		{map(({ label, type, routeId, href, onClick, icon }) => (
			routeId || href ? (
				<Link key={label + routeId} routeId={routeId} href={href}>
					<ButtonNew type={type} icon={icon}>
						{label}
					</ButtonNew>
				</Link>
			)	: (
				<ButtonNew key={label + routeId} onClick={onClick} type={type} icon={icon}>
					{label}
				</ButtonNew>
			)
		), buttons)}
	</div>
))

export const Section = withStyles({
	root: {
		maxWidth: 660,
		[ltMdMediaQuery]: {
			maxWidth: 460,
		},
		[ltSmMediaQuery]: {
			maxWidth: 360,
		},
	},
	...commonStyle,
}, { name: 'MuiSection' })(({
	heading, text, buttons = [], classes, position = 'left', className, align = 'left',
}) => (
	<section className={classNames(
		classes.root,
		classes[position],
		align === 'left' && classes.alignLeft,
		align === 'right' && classes.alignRight,
		className,
	)}
	>
		<Typography
			className={classNames(classes.itemMargin, classes.heading)}
			variant={typographyVariants.heading1}
		>{heading}
		</Typography>
		<Typography
			className={classes.itemMargin}
			variant={typographyVariants.paragraph}
		>{text}
		</Typography>
		<Buttons buttons={buttons} align={align} />
	</section>
))

export const SubheadingSection = withStyles({
	root: {
		maxWidth: 480,
		[ltGtMediaQuery]: {
			maxWidth: 300,
		},
		[ltSmMediaQuery]: {
			maxWidth: 240,
		},
	},
	...commonStyle,
}, { name: 'MuiSubheadingSection' })(({
	heading, subHeading, text, buttons = [], classes, position = 'left', className, align = 'left',
}) => (
	<section className={classNames(
		classes.root,
		classes[position],
		className,
		align === 'left' && classes.alignLeft,
		align === 'right' && classes.alignRight,
	)}
	>
		<Typography
			className={classes.itemMargin}
			variant={typographyVariants.heading3}
		>{heading}
		</Typography>
		<Typography
			className={classes.itemMargin}
			variant={typographyVariants.heading2}
		>{subHeading}
		</Typography>
		<Typography
			className={classes.itemMargin}
			variant={typographyVariants.paragraph}
		>{text}
		</Typography>
		<Buttons buttons={buttons} align={align} />
	</section>
))
